const stateDefault = () => ({
  isVisible: false,
  currentSlot: null,
  direction: 'right',
  size: 'normal',
  props: {},
  queue: []
})

const state = stateDefault()

const getters = {
  isSlideSidebarVisible: ({ isVisible }) => isVisible,

  slideSidebarCurrentSlot: ({ currentSlot }) => currentSlot,

  slideDirection: ({ direction }) =>  direction,

  slideSize: ({ size }) => size,

  slideProps: ({ props }) => props,

  slideQueue: ({ queue }) => queue
}

const mutations = {
  setDirection (state, direction) {
    state.direction = direction
  },

  setSize: (state, size) => state.size = size
}

const actions = {
  slideSidebarToggle({ state, dispatch }, params) {
    if (state.slideSidebarCurrentSlot != params.name) {
      dispatch('slideSidebarShow', params)
    } else {
      dispatch('slideSidebarHide')
    }
  },

  slideSidebarShow({ state }, { name, direction, size, props, queued }) {
    state.currentSlot = null
    state.props = typeof props === 'object' ? props : {}

    window.location.hash = 's-' + name

    if (!queued) {
      state.queue.push({ name, direction, size, props })
    }

    setTimeout(() => {
      state.direction = direction || stateDefault().direction
      state.size = size || stateDefault().size
      state.isVisible = true
      state.currentSlot = name
    }, state.isVisible ? 500 : null)
  },

  slideSidebarBack ({ dispatch, state }) {
    if (state.queue.pop() && state.queue.length) {
      dispatch('slideSidebarShow', { queued: true, ...state.queue[state.queue.length - 1] })
    } else {
      dispatch('slideSidebarHide')
    }
  },

  slideSidebarHide({ state }) {
    state.isVisible = false
    state.currentSlot = null
    state.props = {}
    state.queue = []

    window.location.hash = ''
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
